import React, { useState, useRef } from "react";
import { FaImage, FaInfoCircle, FaCalendarAlt, FaUpload, FaTrash } from "react-icons/fa";

const ChangeGroupPicture = ({
    setEtapaAtual,
    nextStep,
    newGroupPicture,
    setNewGroupPicture,
    schedulingType,
    setSchedulingType,
    scheduledAt,
    setScheduledAt
}) => {
    const notifyColor = window.notifyColor || "#51a197";
    const [error, setError] = useState("");
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setError("A imagem deve ter no máximo 5MB.");
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                setNewGroupPicture(reader.result);
                setError("");
            };
            reader.readAsDataURL(file);
        }
    };

    const handleNext = () => {
        if (!newGroupPicture) {
            setError("Por favor, selecione uma imagem para continuar.");
            return;
        }

        if (schedulingType === "scheduled" && !scheduledAt) {
            setError("Por favor, selecione uma data e hora para o agendamento.");
            return;
        }

        setError("");
        setEtapaAtual(nextStep);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "600px",
                margin: "0 auto",
            }}
        >
            <div style={{ textAlign: "center", marginBottom: 32 }}>
                <div
                    style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        background: `${notifyColor}22`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px",
                        color: notifyColor
                    }}
                >
                    <FaImage size={30} />
                </div>
                <h3 style={{ color: "#005c53", marginBottom: 8, fontSize: "24px" }}>
                    Configuração da Operação
                </h3>
                <p style={{ color: "#666" }}>
                    Carregue a nova imagem de perfil e defina o horário.
                </p>
            </div>

            <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 24 }}>

                {/* ÁREA DE UPLOAD / PREVIEW */}
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px", marginLeft: "4px" }}>
                        Imagem do Perfil
                    </label>

                    <div
                        onClick={() => !newGroupPicture && fileInputRef.current.click()}
                        style={{
                            width: "100%",
                            height: "220px",
                            borderRadius: "20px",
                            border: `2px dashed ${newGroupPicture ? notifyColor : "#cbd5e1"}`,
                            background: newGroupPicture ? "#f8fafc" : "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: newGroupPicture ? "default" : "pointer",
                            position: "relative",
                            overflow: "hidden",
                            transition: "all 0.3s ease"
                        }}
                    >
                        {newGroupPicture ? (
                            <>
                                <img
                                    src={newGroupPicture}
                                    alt="Preview"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                                <div style={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    display: "flex",
                                    gap: 8
                                }}>
                                    <button
                                        onClick={() => fileInputRef.current.click()}
                                        style={{ background: "#fff", border: "none", borderRadius: "8px", padding: "8px", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.1)", color: notifyColor }}
                                    >
                                        <FaUpload size={14} />
                                    </button>
                                    <button
                                        onClick={() => setNewGroupPicture(null)}
                                        style={{ background: "#fff", border: "none", borderRadius: "8px", padding: "8px", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.1)", color: "#ef4444" }}
                                    >
                                        <FaTrash size={14} />
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div style={{ textAlign: "center", color: "#94a3b8" }}>
                                <FaUpload size={40} style={{ marginBottom: 12, opacity: 0.5 }} />
                                <div style={{ fontWeight: "600", fontSize: "15px" }}>Clique para carregar imagem</div>
                                <div style={{ fontSize: "12px" }}>PNG ou JPG até 5MB</div>
                            </div>
                        )}
                        <input
                            type="file"
                            ref={fileInputRef}
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />
                    </div>
                </div>

                {/* OPÇÕES DE AGENDAMENTO */}
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px", marginLeft: "4px" }}>
                        Quando executar?
                    </label>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div
                            onClick={() => setSchedulingType("now")}
                            style={{
                                padding: "16px",
                                borderRadius: "12px",
                                border: `2px solid ${schedulingType === "now" ? notifyColor : "#f1f5f9"}`,
                                background: schedulingType === "now" ? `${notifyColor}08` : "#fff",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                transition: "all 0.2s"
                            }}
                        >
                            <div style={{
                                width: 20, height: 20, borderRadius: "50%", border: `2px solid ${schedulingType === "now" ? notifyColor : "#cbd5e1"}`,
                                display: "flex", alignItems: "center", justifyContent: "center"
                            }}>
                                {schedulingType === "now" && <div style={{ width: 10, height: 10, borderRadius: "50%", background: notifyColor }} />}
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontWeight: "bold", fontSize: "14px", color: schedulingType === "now" ? "#005c53" : "#475569" }}>Executar Agora</span>
                                <span style={{ fontSize: "11px", color: "#94a3b8" }}>Ação imediata</span>
                            </div>
                        </div>

                        <div
                            onClick={() => setSchedulingType("scheduled")}
                            style={{
                                padding: "16px",
                                borderRadius: "12px",
                                border: `2px solid ${schedulingType === "scheduled" ? notifyColor : "#f1f5f9"}`,
                                background: schedulingType === "scheduled" ? `${notifyColor}08` : "#fff",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                transition: "all 0.2s"
                            }}
                        >
                            <div style={{
                                width: 20, height: 20, borderRadius: "50%", border: `2px solid ${schedulingType === "scheduled" ? notifyColor : "#cbd5e1"}`,
                                display: "flex", alignItems: "center", justifyContent: "center"
                            }}>
                                {schedulingType === "scheduled" && <div style={{ width: 10, height: 10, borderRadius: "50%", background: notifyColor }} />}
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontWeight: "bold", fontSize: "14px", color: schedulingType === "scheduled" ? "#005c53" : "#475569" }}>Agendar Horário</span>
                                <span style={{ fontSize: "11px", color: "#94a3b8" }}>Escolher data futura</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DATA E HORA */}
                {schedulingType === "scheduled" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 8, animation: "fadeIn 0.3s ease" }}>
                        <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px", marginLeft: "4px" }}>
                            Data e Hora da Execução
                        </label>
                        <div style={{ position: "relative" }}>
                            <input
                                type="datetime-local"
                                value={scheduledAt}
                                onChange={(e) => {
                                    setScheduledAt(e.target.value);
                                    if (error) setError("");
                                }}
                                style={{
                                    width: "100%",
                                    padding: "14px 18px",
                                    paddingLeft: "45px",
                                    borderRadius: "12px",
                                    border: `2px solid ${error && schedulingType === "scheduled" && !scheduledAt ? "#ef4444" : "#e2e8f0"}`,
                                    fontSize: "16px",
                                    outline: "none",
                                    color: "#334155"
                                }}
                            />
                            <FaCalendarAlt style={{ position: "absolute", left: 18, top: "50%", transform: "translateY(-50%)", color: notifyColor }} />
                        </div>
                    </div>
                )}

                {error && (
                    <div style={{ background: "#fef2f2", padding: "12px", borderRadius: "8px", border: "1px solid #fee2e2", display: "flex", alignItems: "center", gap: 10 }}>
                        <FaInfoCircle style={{ color: "#ef4444" }} />
                        <span style={{ color: "#b91c1c", fontSize: "13px" }}>{error}</span>
                    </div>
                )}

                <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                    <button
                        style={{
                            background: notifyColor,
                            color: "#fff",
                            border: "none",
                            borderRadius: "12px",
                            padding: "14px 80px",
                            fontWeight: "bold",
                            fontSize: 16,
                            cursor: "pointer",
                            boxShadow: `0 4px 14px ${notifyColor}44`,
                            transition: "all 0.3s ease",
                        }}
                        onClick={handleNext}
                    >
                        Revisar Operação
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChangeGroupPicture;